export const templateKeys = {
  all: ['templates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  listByCompany: (companyId: string) => [...templateKeys.lists(), 'byCompany', companyId] as const,
  listByContractType: (contractTypeId: string) => [...templateKeys.lists(), 'byContractType', contractTypeId] as const,
  details: () => [...templateKeys.all, 'detail'] as const,
  detail: (id: string) => [...templateKeys.details(), id] as const,
}
